export default "__VITE_ASSET__odr29Hxy__"